import Moment from 'moment'

/**
 * Simple fetchJSON implementation.
 *
 * @param {string} URL to fetch.
 * @returns {Promise}
 */
export function fetchJSON (url) {
  return fetch(url).then(res => res.json()).catch(err => console.log('err: ', err))
}

/**
 * Cleans airport data.
 *
 * @param {Array} airports Array of airport objects.
 * @return {Array} Returns new array of filtered airports.
 */
export function cleanAirports (airports) {
  let cleaned = airports.citiesCombinations.destinations.map(dest => {
    return {
      countryName: dest.countryName,
      cityName: dest.cityName,
      airportRef: dest.airportRef,
      formattedName: `${dest.cityName}, ${dest.countryName} (${dest.airportRef})`
    }
  })

  return uniqByKey(cleaned, 'airportRef');
}

/**
 * Filter function for ComboBox autocomplete.
 *
 * @param {Object} airport Airport object.
 * @param {string} value Search string to filter.
 * @returns {boolean} Returns `true` if search string is a substring of one of
 *  `countryName`, `cityName`, `IATA` or `formattedName` else `false`.
 */
export function filterAirports (airport, value) {
  const country = airport.countryName.toLowerCase()
  const city = airport.cityName.toLowerCase()
  const ap = airport.airportRef.toLowerCase()
  const formattedName = airport.formattedName.toLowerCase()
  const search = value.toLowerCase()

  return (
    country.indexOf(search) !== -1 ||
    city.indexOf(search) !== -1 ||
    ap.indexOf(search) !== -1 ||
    formattedName.indexOf(search) !== -1
  )
}

/**
 * Creates a duplicate free version of an array of objects by a single `keyName`.
 *
 * @param {Array} array The array to inspect.
 * @param {string} keyName Key name to watch by for duplicates.
 * @returns {Array} Returns the new duplicate free array.
 */
export function uniqByKey (array, keyName) {
  let uniqueKeys = []

  return array.filter(item => {
    const isNew = uniqueKeys.indexOf(item[keyName]) === -1

    if (isNew) {
      uniqueKeys.push(item[keyName])
    }

    return isNew
  })
}

/**
 * Creates a key: value object of params from a URL string.
 *
 * @param {string} url Url string (such as from `document.location.href`)
 * @returns {Object} Returns an object of url params.
 */
export function getURLParams (url) {
  const query = decodeURI(url).split('?')[1]

  if (!query) return

  return query
    .split('&')
    .reduce((obj, item) => {
      const pair = item.split('=')

      // Coerce to number
      if (pair[1].match(/[1-9]+/)) {
        pair[1] *= 1
      }

      obj[pair[0]] = pair[1]

      return obj
    }, {})
}

/**
 * Serializes booking form's state for GET request.
 *
 * @param {Object} state Booking form's React state object.
 * @returns {string} Serialized GET query string.
 */
export function getStateAsQuery (state) {
  const params = {
    next: 1,
    PRICER_PREF: 'SCP2',
    AIRLINES: 'QS',
    JOURNEY_TYPE: state.type.toUpperCase(),
    ADTCOUNT: state.adults,
    CHDCOUNT: state.children,
    INFCOUNT: state.infants,
    FULL_DATE_0: getFormattedDate(state.departureDate.value),
    FULL_DATE_1: getFormattedDate(state.returnDate.value),
    DEP_0: state.from,
    DEP_1: state.from2,
    ARR_0: state.to,
    ARR_1: state.to2
  }

  return Object.keys(params).reduce((query, param, index) => {
    let str = `${param}=${params[param]}`

    if (index > 0) {
      str = `${query}&${str}`
    }

    return str
  }, '')
}

/**
 * Returns formatted date string for form submission.
 *
 * @param {Object} date Instance of Date.
 * @returns {string} Returns date string in D-M-YYYY format or empty string when date not provided.
 */
export function getFormattedDate (date) {
  return date instanceof Date ? Moment(date).format('D-M-YYYY') : ''
}



/** WEBPACK FOOTER **
 ** ./src/helpers.js
 **/